import type { TPageTranslations } from '@crehana/i18n';

import { COURSE_DETAIL_PAGE_KEY } from '../constants';
import type { TKeys } from './types';

const en: TPageTranslations<TKeys, typeof COURSE_DETAIL_PAGE_KEY> = {
  [COURSE_DETAIL_PAGE_KEY]: {
    UPDATED_AT: 'Updated at',
    ABOUT_TITLE: 'About this course',
    LESSONS_SECTION_TITLE: 'Course agenda',
    WATCH_TRAILER: 'Watch trailer',
    NEW: 'New',
    STUDENTS: 'Students',
    SEO_TITLE: 'Online course on',
    SEO_TITLE_2: 'Online course',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    INFO_SECTION_TITLE: 'Course information',
    TOTAL_DURATION: 'Duration:',
    TOTAL_ATTACHMENTS_TEXT: ' Attachments',
    ATTACHMENT_TEXT: ' Attachment',
    ACCESS_TEXT: 'Access through the app',
    TRY_COURSE: 'Try for free!',
    TEMPORAL_ACCESS: 'Free access for 24hrs!',
    FREE_SUBSCRIPTION: 'Register for free!',
    SUBSCRIBE_NOW: 'SUBSCRIBE NOW!',
    GO_TO_COURSE: 'Go to course',
    REQUIRED: 'Required',

    LEVEL_LABEL: 'Level',
    LEVEL_TITLE: 'DIFFICULTY',
    MODULES: '{{count}} Module',
    MODULES_plural: '{{count}} Modules',
    LESSONS_TOTAL: '{{count}} Lesson',
    LESSONS_TOTAL_plural: '{{count}} Lessons',
    TIME_DURATION: '{{totalDuration}} total duration',

    ERROR_VIEW_MESSAGE: 'An error occurred, please try again',
    ERROR_VIEW_BUTTON: 'Reload page',
    ERROR_VIEW_COURSE_NOT_FOUND: 'Course not available',
    ERROR_VIEW_COURSE_NOT_FOUND_DESCRIPTION:
      'This course may not exist, may belong to another organization, or you may not have the necessary permissions to access it. Please contact your administrator if you believe this is an error.',
    ERROR_VIEW_COURSE_NOT_FOUND_BUTTON: 'Go back to previous page',
    KNOWLEDGEHUB_HOME: 'Catalog',
    KNOWLEDGEHUB_DETAIL: 'Course detail',

    ENROLLMENTS_CURRENT_COURSE_DIALOG_TITLE:
      'Enrolled collaborators in the course',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION:
      'Check the list of collaborators enrolled in the course. You can see who has been added.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION_BOLD:
      'New assignments may take a few minutes to process before being displayed.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_TITLE: 'Users',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_SEARCH: 'Search',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_NAME: 'Name',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_ROLE: 'Assigned',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_ROLE_ADMINISTRATOR: 'Administrator',
    ENROLLMENTS_CURRENT_COURSE_EMPTY:
      'No collaborators under your charge have this course assigned.',
    ENROLLMENTS_CURRENT_COURSE_INFO:
      'Check the list of your collaborators enrolled in the course. You can see who assigned the content.',
    ENROLLMENTS_CURRENT_COURSE_INFO_AVATAR_LABEL: 'Collaborators',
    ENROLLMENTS_CURRENT_COURSE_INFO_BUTTON: 'View more',
    ENROLLMENTS_CURRENT_COURSE_INFO_NOTE:
      'Assignments may take at least an hour or more for the data to be reflected in the list.',
    LEADER_ASSIGN_TEAM_BUTTON: 'Assign to my team',

    ENROLLMENTS_CURRENT_COURSE_ERROR_TITLE: 'Error loading data',
    ENROLLMENTS_CURRENT_COURSE_ERROR_DESCRIPTION:
      "We couldn't load the enrollment information. Please try again.",
    ENROLLMENTS_CURRENT_COURSE_ERROR_BUTTON: 'Retry',
  },
};

export default en;
